"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedmakeup = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 56 52",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedmakeup` : '') + (description ? ` desc-brandedmakeup` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedmakeup"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedmakeup"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "m51.86 21 .11-19.92c0-.22-.06-.42-.18-.6a1.07 1.07 0 0 0-1.11-.46c-.2.04-.4.14-.56.29l-8.44 8.22a2.16 2.16 0 0 0-.64 1.52l-.07 10.91 10.9.04h-.02.01Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m56 34.92-.02 14.95c0 .57-.23 1.1-.65 1.51-.42.4-.98.62-1.57.62l-15.54-.01c-.59 0-1.15-.22-1.57-.63-.42-.4-.65-.94-.65-1.5l.01-14.96c0-.3.12-.56.33-.76.21-.2.5-.31.78-.31h1.12V22.07A1.1 1.1 0 0 1 39.35 21l13.32.01c.29 0 .58.12.78.32.21.2.33.47.33.75v11.74h1.11c.3 0 .57.12.79.31.2.2.32.47.32.76v.03Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M55.98 49.85a2.15 2.15 0 0 1-1.29 1.97c-.27.11-.56.18-.85.18l-15-.02c-.19 0-.5.01-.83-.01a2.13 2.13 0 0 1-1.31-.57c-.52-.5-.7-.99-.7-1.56V46.3a92.93 92.93 0 0 0 17.8-12.5h1.11c.29 0 .56.11.76.31.2.2.3.47.3.76v14.98Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M26.43 0H2.57A2.56 2.56 0 0 0 0 2.57v46.87A2.57 2.57 0 0 0 2.57 52h23.86A2.56 2.56 0 0 0 29 49.44V2.57A2.57 2.57 0 0 0 26.43 0Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2.23 0H5v52H2.23A2.26 2.26 0 0 1 0 49.7V2.3C0 1.04 1 0 2.23 0Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.3 4.9c.58-.4 1.3.1 1.3.86 0 .35-.17.7-.44.87l-2.1 1.4c.41.79.76 1.63.98 2.52l2.27-.44c.47-.1.9.28.99.82l.01.17c0 .49-.3.9-.71.99l-2.2.42c.07.83.07 1.67 0 2.5l2.2.43c.42.08.72.5.72.98 0 .06 0 .12-.02.17-.07.55-.52.91-.98.82l-2.27-.44a11.8 11.8 0 0 1-.99 2.51l2.12 1.4c.58.4.58 1.36 0 1.75a.76.76 0 0 1-.86 0l-2.3-1.54c-.4.52-.84 1-1.3 1.44-.54.47-1.3.08-1.38-.68-.03-.33.08-.65.29-.87a9.71 9.71 0 0 0 3.12-7.22 9.67 9.67 0 0 0-3.12-7.22c-.5-.5-.38-1.44.24-1.7.29-.14.6-.07.84.14.46.45.9.93 1.3 1.45l2.31-1.54v-.01l-.01.01Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.3 29.02c.58-.39 1.3.1 1.3.86 0 .36-.17.7-.44.87l-2.1 1.4c.41.8.76 1.63.98 2.52l2.27-.44c.47-.1.9.28.99.82l.01.17c0 .5-.3.9-.71.99l-2.2.42c.07.84.07 1.68 0 2.5l2.2.43c.42.08.72.5.72.99 0 .06 0 .1-.02.17-.07.54-.52.9-.98.81l-2.27-.44a11.8 11.8 0 0 1-.99 2.51l2.12 1.41c.58.39.58 1.35 0 1.74a.76.76 0 0 1-.86 0l-2.3-1.54c-.4.52-.84 1-1.3 1.45-.54.46-1.3.07-1.38-.68-.03-.34.08-.66.29-.88a9.7 9.7 0 0 0 3.12-7.22 9.67 9.67 0 0 0-3.12-7.22c-.5-.49-.38-1.44.24-1.7.29-.13.6-.07.84.15.46.44.9.92 1.3 1.44l2.31-1.53V29l-.01.02Z",
    fill: "#E90B5A"
  }));
};
var _default = exports.default = brandedmakeup;